<template>
  <form class="search-form" action="/search">
    <input type="hidden" name="type" value="article,page,product"/>
    <input type="hidden" name="options[prefix]" value="last"/>
    <div class="input">
      <label class="u-sr-only" for="q">Search</label>
      <search-input
        ref="searchInput"
        :placeholder="placeholder"
        v-model="searchValue"></search-input>
    </div>
    <button type="submit" class=search-form__submit>
      <icon name="arrow_long_right" :size="submitIconSize"></icon>
    </button>
  </form>
</template>

<script>
import SearchInput from '@/scripts/components/forms/SearchInput.vue'
import Icon from '@/scripts/components/basic/Icon.vue'
import { FadeTransition } from 'vue2-transitions'

export default {
  name: 'SearchForm',
  components: {
    SearchInput,
    Icon,
    FadeTransition
  },
  data () {
    return {
      searchValue: '',
    }
  },
  props: {
    inputPlaceholder: String,
    submitIconSize: {
      type: String,
      default: '40px'
    }
  },
  computed: {
    // cannot use default prop because empty strings
    // get passed from shopify.
    placeholder () {
      return this.inputPlaceholder || 'Search'
    }
  }
}
</script>

<style scoped lang="scss">
.search-form {
  width: 100%;
  position: relative;
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
  align-items: center;

  &__submit {
    cursor: pointer;
    display: block;
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    z-index: 1;
  }

  @include desktop-up {
    background-color: $color-white;
    padding: 0;
    right: 0;
    left: auto;
    max-width: 300px;
    position: absolute;
    width: 100%;
    height: 43px;
  }

  .input {
    margin: 0;
    width: 100%;
  }
}

/deep/ .button__content {
  display: flex;
}

/deep/ .search-input::-webkit-input-placeholder, /* Chrome/Opera/Safari */
/deep/ .search-input::-moz-placeholder, /* Chrome/Opera/Safari */
/deep/ .search-input:-ms-input-placeholder,/* Chrome/Opera/Safari */
/deep/ .search-input:-moz-placeholder { /* Chrome/Opera/Safari */
  color: $color-grey;
}

/deep/ .search-input::placeholder {
  color: $color-grey;
}
</style>
